var methods = {
  showit: (e)=>{
    console.log("show");
    console.log(e);
  }
};

export default methods;
